<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
        <div class="flex- flex-row justify-content-between">
            <a class="navbar-brand" href="javascript:void(0)">App Games Category Management</a>
            <a class="btn btn-sm btn-outline-primary" [routerLink]="['/lo', company_uuid, 'front', 'category', 'form']">&#43; Add Game Category</a>    
        </div>
    </div>
</nav>
<hr/>
<div class="row">
    <app-table #table></app-table>
</div>